import React from "react";
export function IndexColumnFormatter(cellContent, row, index) {
    return (<div>{index + 1}</div>)
}


